<template>
    <!-- 耕雲導師安祥禪簡介 -->
    <div class="brief2">
        <!-- <h3 class="title">{{$t('plowCloudBrief')}}</h3> -->
        <h3 class="title">{{content.news_title}}</h3>
        <div class="briefContent">
            <div v-html="content.news_content"></div>
            <!-- <div>吾耕雲導師天縱聖明，乘願再來，早年悟道，經過數十年的涵養，成就非凡，非但深入禪的閫奧，且具有偉大的傳心力量。凡有緣親近之人，莫不親領法喜禪悅，同聲讚嘆，慶幸、珍惜此一稀有難得之法緣。如今蒙耕雲導師啟發而悟道者不在少數，成就證果者亦大有人在，均得力於耕雲導師「傳佛心印」的威力和「法門的簡易」。</div> -->
        </div>
    </div>
</template>

<script>
import {getIntroduction} from '../../api/apis'
export default {
    name: "",
    components: {},
    props: ["cateId"],
    data() {
        return {
            content: {} //简介内容
        };
    },
    methods: {
        changShowList(index) {
            this.contentStatus.splice(index, 1, !this.contentStatus[index]);
        }
    },
     mounted(){
      this.cateId = this.cateId || 5;
      getIntroduction(this.cateId).then(res => {
        this.content = res;
      })
    }
};
</script>

<style scoped>
.brief2 {
    padding: 0.64rem;
    color: #333333;
}
.title {
    font-size: 0.85rem;
    line-height: 1.49rem;
    font-weight: 600;
}
.briefContent {
    margin-top: 0.8rem;
    font-size: 0.69rem;
    font-size: 0.85rem;
    line-height: 1.4rem;
}
</style>